import React from "react";

const OrderedListStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.25 2.75V8.25M4.25 8.25H2.75M4.25 8.25H5.25",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.25 12.25H9.6562C8.9255 12.25 8.5182 11.4359 8.9058 10.8574C8.9535 10.7861 9.0211 10.7311 9.0925 10.6836L10.8924 9.486C10.9638 9.4384 11.0312 9.3832 11.0799 9.3126C11.5253 8.6678 11.0713 7.75 10.2526 7.75H8.75",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.75 12.75H16.1964C17.4308 12.75 17.6499 14.6376 16.5101 14.9556C16.4549 14.971 16.397 14.9772 16.3398 14.9792L15.75 15L16.3398 15.0208C16.397 15.0228 16.4549 15.0289 16.5101 15.0444C17.6499 15.3624 17.4308 17.25 16.1964 17.25H14.75",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(OrderedListStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;